import gql from 'graphql-tag';

export const MY_ORGANIZATION_RESILIENCE_PULSE_CHECK = gql`
  query myOrganizationResiliencePulseCheck {
    myOrganizationResiliencePulseCheck
  }
`;
